import { MODEL_VERSION_SETTINGS_MAP, RESOLUTION_MAP } from '@/app/constants';
import type { FormParams } from '@/app/stores/slices/task-form';
import type { FormSettingsKey } from '@/app/types';

/**
 * 获取指定模型版本下的最大图像尺寸
 *
 * @param formParams - 表单参数对象，包含不同版本的设置数据
 * @returns 返回对应配置的最大图像尺寸（像素数）
 */
export const getMaxImageSize = (formParams: FormParams) => {
  const formKey: FormSettingsKey = MODEL_VERSION_SETTINGS_MAP[formParams.modelVersion];
  const finalResolution = formParams[formKey].resolution;
  let size = 0;
  switch (finalResolution) {
    case '512':
      size = RESOLUTION_MAP['512'];
      break;
    case '720p':
      size = RESOLUTION_MAP['720p'];
      break;
    case '1080p':
      size = RESOLUTION_MAP['1080p'];
      break;
  }
  return size;
};
